/* eslint no-undef: 0 */
/* eslint arrow-parens: 0 */
import React from 'react';
import request from "../utils/api";
import { enquireScreen } from 'enquire-js';

import Chart6 from './Chart6';

import {
  Chart60DataSource,
  Chart61DataSource,
  Chart62DataSource
} from '../utils/farebox.source';
import './less/antMotionStyle.less';
let isMobile;
enquireScreen((b) => {
  isMobile = b;
});

const { location = {} } = typeof window !== 'undefined' ? window : {};

export default class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile,
      show: !location.port, // 如果不是 dva 2.0 请删除,
      contentData: {
        percent: [],
        search_count: [],
        time_consuming: []
      }
    };
  }

  componentDidMount() {
    // 适配手机屏幕;
    enquireScreen((b) => {
      this.setState({ isMobile: !!b });
    });
    // dva 2.0 样式在组件渲染之后动态加载，导致滚动组件不生效；线上不影响；
    /* 如果不是 dva 2.0 请删除 start */
    if (location.port) {
      // 样式 build 时间在 200-300ms 之间;
      setTimeout(() => {
        this.setState({
          show: true,
        });
      }, 500);
    }
    /* 如果不是 dva 2.0 请删除 end */
    // 获取performance数据
    this.getPerformanceData()
  }

  getPerformanceData  = (page) => {
    request('performance').then(res => {
      const { status, data } = res
      if (status === 0) {
        this.setState({
          contentData: data
        })
      }
    }).catch(e =>{
      console.log("error:" + JSON.stringify(e))
    })
  }

  render() {
    const children = [
      <Chart6
        id="Chart6_0"
        key="Chart6_0"
        dataSource={Chart60DataSource}
        backSource={this.state.contentData.search_count}
        isMobile={this.state.isMobile}
      />,
      <Chart6
        id="Chart6_1"
        key="Chart6_1"
        dataSource={Chart61DataSource}
        backSource={this.state.contentData.time_consuming}
        isMobile={this.state.isMobile}
      />,
      <Chart6
        id="Chart6_2"
        key="Chart6_2"
        dataSource={Chart62DataSource}
        backSource={this.state.contentData.percent}
        isMobile={this.state.isMobile}
      />,
      <div className="performance-sps" key='performanceSps'></div>
    ];
    return (
      <div
        className="templates-wrapper"
        ref={(d) => {
          this.dom = d;
        }}
      >
        {/* 如果不是 dva 2.0 替换成 {children} start */}
        {this.state.show && children}
        {/* 如果不是 dva 2.0 替换成 {children} end */}
      </div>
    );
  }
}
